import React from 'react'

// components
import FormTextFieldWithValidation from 'components/shared/FormTextFieldWithValidation'

const RegionInputInternational = props => {
  const { onChangeFormField, form, formErrors } = props

  return (
    <FormTextFieldWithValidation
      label='State/Province'
      field='region'
      form={form}
      onChange={onChangeFormField}
      errors={formErrors}
      required
    />
  )
}

export default RegionInputInternational
